import { useEffect, useMemo, useState } from "react";
import { usePreviewScheduleQuery } from "~/shared/api/container-group-schedule/container-group-schedule.grpc";
import { formToPreview, validateScheduleForm } from "../lib/schedule-form";
import type { ScheduleForm } from "./types";

const PREVIEW_DEBOUNCE_MS = 400;

/** PreviewSchedule for the form once it stops changing; a form that would not save is not sent. */
export const useSchedulePreview = (form: ScheduleForm, editingId?: string) => {
  const key = JSON.stringify(form);
  const [settledKey, setSettledKey] = useState(key);
  useEffect(() => {
    const timer = setTimeout(() => setSettledKey(key), PREVIEW_DEBOUNCE_MS);
    return () => clearTimeout(timer);
  }, [key]);

  const settled = useMemo(() => JSON.parse(settledKey) as ScheduleForm, [settledKey]);
  const ready = validateScheduleForm(settled) === null;
  const query = usePreviewScheduleQuery(formToPreview(settled, editingId), { skip: !ready });

  return {
    preview: ready ? query.currentData : undefined,
    error: ready ? query.error : undefined,
  };
};
